export interface IGeneral {
  modalEdit: {
    open: boolean
    title: string
    message: string
    onConfirmEdit: any
  } 
  
  modalError: {
    open: boolean
    message: string
    tipo: number | string
  }
  modalInfo: {
    open: boolean
    message: string
  }
  modalSuscripcion: {
    open: boolean
  }
  modalMessage: {
    open: boolean
    title: string
    message: string
  }
  toast: {
    open: boolean
    title: string
    message: string
    tipo: number /* 0 = error, 1 = success, 2 = info */
  }
  modalLimite: {
    open: boolean
    title: string
    message: string
    color: string
    limite: number
  }
  loader: boolean
  fecha_actual: any
  validReturnHome: string // Regresar a home sin mensaje de salida
}

export type GeneralState = IGeneral

export type GeneralAction = {
  type: string
  payload: any
}

export type DispatchType = (args: GeneralAction) => GeneralAction

export const limitesSuscripcion = [
  {inferior: 95, superior: 100, color: '#D90F15'},
  {inferior: 85, superior: 95, color: 'rgb(255, 83, 0)'},
  {inferior: 75, superior: 85, color: 'rgb(215, 140, 0)'},
]

export interface DocFisico {
  numId: string
  tipo: string 
  fecha: string 
  monto: string 
}